export const styles = {
    container: {
        display: "flex",
        flexDirection: "column",
        height: "100%"
    },
    header: {
        display: "flex",
        flexDirection: "column",
        p: 3,
        gap: 2,
        borderBottom: theme => `1px solid ${theme.palette.greyscale[200]}`
    },
    tableContainer: (TABLE_HEIGHT, TABLE_PADDING) => ({
        gap: 2,
        display: "flex",
        flexDirection: "column",
        p: `${TABLE_PADDING}px`,
        height: TABLE_HEIGHT,
        flexGrow: 1,
        minHeight: 0,
        "& .ag-row .ag-cell": {
            lineHeight: "0px !important",
            pt: "12px",
            pb: "12px",
            alignContent: "center"
        },
        "& .row-selection-disabled": {
            cursor: "not-allowed",
            "& .ag-cell[col-id='0']": {
                ml: "-10px"
            },
            "& .ag-selection-checkbox": {
                display: "none !important"
            }
        }
    }),
    customTooltip: {
        backgroundColor: "greyscale.900",
        padding: "4px 8px",
        borderRadius: "4px",
        maxWidth: "300px"
    }
};
